import React, { useEffect, useState } from "react";
import Drift from "drift-zoom";
import { useParams, useNavigate } from "react-router-dom";
import "./Productdetail.css";
import { fetchProductBySlugOrId, createSlug } from "../../Helper/index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Productdetail = () => {
  const { productSlug, productId } = useParams();
  const slugOrId = productSlug || productId;
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    country: "",
    postalCode: "",    
    productname: "",
    productmodel: "",
    requirement: "",
    consent: false,
  });

  // Simulating fetching data
  useEffect(() => {
    if (!productDetails) return; // Ensure productDetails is available
  
    const { modeldesc, modelName } = productDetails; // Destructure here
  
    const fetchData = async () => {
      const data = {
        productname: modeldesc || "",
        productmodel: modelName || "",
      };
      setFormData((prevData) => ({
        ...prevData,
        ...data,
      }));
    };
  
    fetchData();
  }, [productDetails]); // ✅ Only use `productDetails` as a dependency
  

  // Product categories
  const products = {
    combineHarvester: [
      { id: "1", productName: "Dasmesh 9100", subCate: "Combineharvester" },
      {
        id: "2",
        productName: "Dasmesh 9100 Maize",
        subCate: "Combineharvester",
      },
      { id: "3", productName: "Dasmesh 7100", subCate: "Combineharvester" },
      { id: "4", productName: "Dasmesh 3100", subCate: "Combineharvester" },
      { id: "5", productName: "Dasmesh 912 2WD", subCate: "Combineharvester" },
      { id: "6", productName: "Dasmesh 912 4WD", subCate: "Combineharvester" },
      {
        id: "7",
        productName: "Dasmesh 731 Track",
        subCate: "Combineharvester",
      },
      {
        id: "8",
        productName: "Dasmesh 726 Track",
        subCate: "Combineharvester",
      },
      {
        id: "9",
        productName: "Dasmesh Maize Header",
        subCate: "Combineharvester",
      },
       {
        id: "20",
        productName: "Dasmesh 831",
        subCate: "Combineharvester",
      },
    ],
    agriImplements: [
      { id: "10", productName: "Dasmesh Rotavator", subCate: "agriImplements" },
      {
        id: "11",
        productName: "Dasmesh Laser Land Leveller",
        subCate: "agriImplements",
      },
      {
        id: "12",
        productName: "Dasmesh Super Seeder",
        subCate: "agriImplements",
      },
      {
        id: "13",
        productName: "Dasmesh Straw Reaper",
        subCate: "agriImplements",
      },
      {
        id: "19",
        productName: "Dasmesh Paddy Straw Chopper",
        subCate: "agriImplements",
      },
      {
        id: "14",
        productName: "Dasmesh Square Baler",
        subCate: "agriImplements",
      },
      {
        id: "15",
        productName: "Dasmesh Round Baler",
        subCate: "agriImplements",
      },
      { id: "16", productName: "Dasmesh Hey Rake", subCate: "agriImplements" },
      {
        id: "17",
        productName: "Dasmesh Zero Till Drill",
        subCate: "agriImplements",
      },
      { id: "18", productName: "Dasmesh DSR Drill", subCate: "agriImplements" },
    
    ],
  };

  // Initial fetch using productSlug/productId from route
  useEffect(() => {
    const details = fetchProductBySlugOrId(slugOrId);
    setProductDetails(details);
  }, [slugOrId]);

  // Handle product selection from dropdown
  const handleProductSelection = (id, productName) => {
    const slug = createSlug(productName);
    navigate(`/${slug}`);
    setSelectedProduct(productName);
    setOpenDropdown(null);
  };

  // Initialize Drift Zoom after product details are fetched
  useEffect(() => {
    if (!productDetails) return;

    const triggerElement = document.querySelector(".drift-demo-trigger");
    const paneContainerElement = document.querySelector(".product-details-img");

    if (triggerElement && paneContainerElement) {
      const driftInstance = new Drift(triggerElement, {
        paneContainer: paneContainerElement,
        inlinePane: 769,
        inlineOffsetY: -85,
        containInline: true,
        hoverBoundingBox: true,
      });

      return () => {
        driftInstance.destroy();
      };
    }
  }, [productDetails]);

  // Handle manual download
  const handleDownload = () => {
    if (productDetails?.pdflink) {
      setIsClicked(true);
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = productDetails.pdflink;
        link.download = productDetails.pdflink.split("/").pop();
        link.click();
        setIsClicked(false);
      }, 500);
    } else {
      console.error("PDF link not found!");
    }
  };

  // Toggle Dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  // Render loading state if product details are not ready
  if (!productDetails) {
    return <div>Loading...</div>;
  }

  // Destructure product details
  const {
    imgSrc,
    modelName,
    modeldesc,
    specifications,
    highlights,
    maintenanceTips,
    modeldescprod,
    modelNamedescription,
  } = productDetails;

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData((prevData) => ({ ...prevData, [name]: numericValue }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://dasmesh-mailer.ritaz.in/dealership-send-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Email sent successfully!");
        resetForm();
      } else {
        toast.error("Error sending email!");
      }
    } catch (error) {
      toast.error("Error sending email!");
    } finally {
      setLoading(false);
    }
  };

  // Default form data
  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    requirement: "",
    productname: "",
    productmodel: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData);
    setIsOpen(false);
  };
  

  return (
    <>
      <div className="hmsectionprodu-detail-1">
        <div className="row">
          <div className="col-lg-6 col-md">
            <div className="product-details-img" id="product-detail-desktop">
              <img
                className="drift-demo-trigger"
                data-zoom={imgSrc}
                src={imgSrc}
                alt="productdetails"
              />
            </div>
            <div className="product-details-img" id="product-detail-mobile">
              <img src={imgSrc} alt="productdetails" />
            </div>
            <div className="product-detail-desktop">
              <div className="product-detail-buttons-2">
                <span>Technical Specification</span>
              </div>
              <div className="product-detail-speciaficaton-table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Specification</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specifications && specifications.length > 0 ? (
                      specifications.map((spec, index) => (
                        <tr key={index}>
                          <td>{spec.category}</td>
                          <td>{spec.specification}</td>
                          <td>{spec.value}</td>
                          <td>{spec.valuetation}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3">No specifications available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md">
            {/* Dropdown */}
            <div className="dropdown-container">
              {Object.entries(products).map(([key, items]) => (
                <div className="dropdown" key={key}>
                  <div
                    className="dropdown-header"
                    onClick={() => toggleDropdown(key)}
                  >
                    <span>
                      {key === "combineHarvester"
                        ? "Combine Harvesters"
                        : "Agri. Implements"}
                    </span>
                    <span
                      className="arrow"
                      style={{
                        transform:
                          openDropdown === key
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                      }}
                    >
                      ▼
                    </span>
                  </div>
                  {openDropdown === key && (
                    <div className="dropdown-options">
                      {items.map((item) => (
                        <p
                          key={item.id}
                          onClick={() =>
                            handleProductSelection(item.id, item.productName)
                          }
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedProduct === item.productName
                                ? "#f0f0f0" // Highlight color
                                : "transparent",
                            padding: "8px",
                            borderRadius: "4px",
                          }}
                        >
                          <span>{item.productName}</span>
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <br />
            <div className="product-detail-content">
              <div className="row">
                <div className="col-7">
                  <div className="product-details-name">{modeldesc}</div>
                </div>
                <div className="col-5">
                  <div className="product-details-downlord-icon">
                    <button
                      onClick={productDetails?.pdflink ? handleDownload : null}
                      className={`download-btn ${
                        isClicked ? "download-animation" : ""
                      }`}
                      style={{
                        cursor: productDetails?.pdflink
                          ? "pointer"
                          : "not-allowed",
                      }}
                      disabled={!productDetails?.pdflink} // Disable button if no link
                    >
                      DOWNLOAD MANUAL
                      <i className="fa-solid fa-circle-arrow-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <br />
              <div className="product-detils-content-img-name">
                <h4>{modelName}</h4>
                <p>{modelNamedescription}</p>
              </div>
              {/* <div className="product-details-name-2"></div> */}
              <div className="product-detail-maintence">
                <h2>Product Highlights</h2>
              </div>
              <div className="product-details-hightlight">
                {Array.isArray(highlights) && highlights.length > 0 ? (
                  highlights.map((highlight, index) => (
                    <span key={index}>{highlight}</span>
                  ))
                ) : (
                  <p>No highlights available</p>
                )}
              </div>
              {modeldescprod && (
                <div className="product-details-description">
                  <div className="product-detail-maintence">
                    <h2>Description</h2>
                  </div>
                  <p>{modeldescprod}</p>
                </div>
              )}
            </div>
            <div
              className="product-detail-buttons-2"
              id="enquire-now-button"
              onClick={() => setIsOpen(true)}
            >
              <span>Enquire Now</span>
            </div>

            {/* Modal */}
            {isOpen && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <button
                    className="close-btn"
                    onClick={() => setIsOpen(false)}
                  >
                    ✖
                  </button>
                  <h2>Enquire Now</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="Email Address"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <br />
                    <div className="form-row">
                      <div className="form-group">
                        <input
                          type="text"
                          id="productname"
                          name="productname"
                          placeholder="Product Name"
                          value={formData.productname || modeldesc || ""}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          id="productmodel"
                          name="productmodel"
                          placeholder="Product Model"
                          value={formData.productmodel || modelName || ""}
                          readOnly
                        />
                      </div>
                    </div>

                    <br />
                    <div className="form-row">
                      <div className="form-group">
                        <input
                          type="text"
                          id="postalCode"
                          name="postalCode"
                          placeholder="Postal Code"
                          value={formData.postalCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          id="phone"
                          name="phone"
                          placeholder="Phone No."
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <br />
                    <div className="form-row">
                      <div className="form-group">
                        <input
                          type="text"
                          id="city"
                          name="city"
                          placeholder="City"
                          value={formData.city}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          id="country"
                          name="country"
                          placeholder="Country"
                          value={formData.country}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <br />
                    <div className="form-group">
                      <textarea
                        id="requirement"
                        name="requirement"
                        placeholder="Describe Your Requirement"
                        value={formData.requirement}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
                    <button className="product-form-buttons-2" type="submit" disabled={loading}>
                      {loading ? "Sending..." : "Send Email"}
                      
                    </button>
                  </form>
                  {/* Toast container */}
                 
                </div>
              </div>
            )}

<ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                  />
            <div
              className="product-detail-maintence"
              style={{ display: "none" }}
            >
              <div className="product-detail-buttons-2">
                <span>Maintenance Tips</span>
              </div>

              <h2>Maintenance & Servicing Tips</h2>
              {Array.isArray(maintenanceTips) && maintenanceTips.length > 0 ? (
                maintenanceTips.map((tip, index) => (
                  <div key={index}>
                    <h3>{tip.title}</h3>
                    <p>{tip.description}</p>
                  </div>
                ))
              ) : (
                <p>No maintenance tips available</p>
              )}
            </div>
            <div className="product-detail-mobile">
              <div className="product-detail-buttons-2">
                <span>Technical Specification</span>
              </div>
              <div className="product-detail-speciaficaton-table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Specification</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specifications && specifications.length > 0 ? (
                      specifications.map((spec, index) => (
                        <tr key={index}>
                          <td>{spec.category}</td>
                          <td>{spec.specification}</td>
                          <td>{spec.value}</td>
                          <td>{spec.valuetation}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3">No specifications available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Productdetail;
